import { Dialog } from "quasar";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,
  history: createWebHistory(),
});

// Navigation guard to prevent back navigation during test
router.beforeEach((to, from, next) => {
  // Update document title
  const title = to.meta.title as string | undefined;
  if (title) {
    document.title = `${title} | Potenzialanalyse`;
  }

  // Check if we're navigating backwards on a preventBack route
  if (from.meta.preventBack && !to.meta.preventBack) {
    // Allow forward navigation to complete page
    if (to.name === 'complete') {
      next();
      return;
    }

    // Block backward navigation (e.g., back to landing page)
    Dialog.create({
      title: "Navigation nicht möglich",
      message: "Sie können während der Potenzialanalyse nicht zurückgehen. Bitte beantworten Sie die aktuelle Frage.",
      persistent: true,
      ok: {
        label: "Verstanden",
        color: "primary",
      },
    });
    next(false);
    return;
  }

  next();
});

// Handle browser back button - initialize after router is ready
if (typeof window !== "undefined") {
  // Track if popstate handler is registered
  let popstateHandlerRegistered = false;

  router.isReady().then(() => {
    if (popstateHandlerRegistered) return;
    popstateHandlerRegistered = true;

    window.addEventListener("popstate", () => {
      const currentRoute = router.currentRoute.value;
      if (currentRoute.meta.preventBack) {
        // Push the current route back onto the history stack
        history.pushState(null, "", window.location.href);
      }
    });

    // Add initial history entry for preventing back navigation
    // Only if we're on a preventBack route
    if (router.currentRoute.value.meta.preventBack) {
      history.pushState(null, "", window.location.href);
    }
  });
}

export default router;
